import { ActionButton } from "@lib/components/MiniComponents/Buttons";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import ProviderName from "@lib/components/MiniComponents/Others/ProviderName";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import ROUTES from "@lib/constants/Routes";
import { getRoute } from "@lib/helpers/RouteHelper";
import { shortenString } from "@lib/helpers/StringHelper";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { UseMutationProps } from "@lib/types/Api";
import { TableColumnsProps } from "@lib/types/General";
import { Provider } from "@lib/types/Provider";
import { Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";

type Props<T> = TableColumnsProps<T> & {
  openModal: boolean;
  handleSelectProvider: (manager: T) => void;
  deleteMutation: UseMutationProps<T>;
  updateMutation: UseMutationProps<Partial<T>>;
};

const getColumns = <T extends Provider>(props: Props<T>): ColumnsType<T> => {
  const { deleteMutation, handleSelectProvider, messages, updateMutation } =
    props;

  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "ID",
      dataIndex: "id",
      width: "160px",
      render: (value) => (
        <TableIdButton
          text={`${shortenString(value)}`}
          textToBeCopied={value}
        />
      ),
      filterType: "search",
    },

    {
      title: "common.providerName",
      dataIndex: "name",
      render: (v, r) => <ProviderName provider={r} link />,
      filterType: "search",
      width: "220px",
    },
    {
      title: "common.status",
      dataIndex: "enabled",
      width: "100px",
      render: (_, record) => (
        <Switch
          size="default"
          checkedChildren={messages["common.enabled"] as string}
          unCheckedChildren={messages["common.disabled"] as string}
          checked={record.enabled}
          onChange={(checked: boolean) => {
            updateMutation.mutate({
              ...record,
              enabled: checked,
            });
          }}
        />
      ),
      filterType: "dropdown",
      filters: [
        { text: messages["common.enabled"] as string, value: true },
        { text: messages["common.disabled"] as string, value: false },
      ],
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "180px",
      render: (d) => dayjs(d).format("DD/MM/YYYY"),
    },
    {
      title: "common.createdBy",
      dataIndex: "createdBy",
      width: "180px",
      filterType: "dropdown",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "110px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="detail"
            href={getRoute(ROUTES.ADMIN.PAYMENT_PROVIDER.DETAIL, {
              providerId: record.id,
            })}
            noLabel
          />

          <ActionButton
            type="edit"
            onClick={() => handleSelectProvider(record)}
            noLabel
          />

          <ActionButton
            type="delete"
            onClick={() => deleteMutation.mutate(record)}
            itemName="common.provider"
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};

export default getColumns;
